import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AchievementsSection } from './components/AchievementsSection';
import { CollectionSection } from './components/CollectionSection';
import { BonusesSection } from './components/BonusesSection';
import { TargetSection } from './components/TargetSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-[#FF9F43] selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <AchievementsSection data-id="element-6" />
        <CollectionSection data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <TargetSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}